import PropTypes from "prop-types";
import React, { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";

import SectorsChart from "./SectorsChart";
import SectorsDataTable from "./SectorsDataTable";

import ActiveComponentContext from "../../../contexts/ActiveComponentContext";
import useOutputReportStore from "../../../store/OutputReport.store";

const getSectorId = (type) => {
  const idMap = {
    gics: "SectorsGICS",
    risk: "SectorsRiskExposure",
  };

  return idMap[type] || "Sectors";
};

const SectorsReport = ({ reportName, type }) => {
  const data = useOutputReportStore((state) => state.data);
  const { active: activeId, setActive: setActiveComponent } = useContext(
    ActiveComponentContext
  );
  const { ref, entry } = useInView({
    /* Optional options */
    threshold: 0.25,
    trackVisibility: true,
    delay: 100,
  });

  useEffect(() => {
    if (entry?.isVisible && entry?.target?.id !== activeId) {
      setActiveComponent(entry.target.id);
    }
  }, [entry, setActiveComponent, activeId]);

  if (type === "gics") {
    reportName = "Sectors (GICS)";
  }

  if (type === "risk") {
    reportName = "Sectors (Risk Exposure)";
  }

  if (!data?.[reportName]) {
    return null;
  }

  return (
    <article ref={ref} id={getSectorId(type)} className="report-article">
      <header className="section-title report-article__header">
        <h1>
          {reportName === "Sector"
            ? "Proposed Sectors"
            : `${
                reportName.includes("GICS")
                  ? "Sectors (GICS®)[1]"
                  : "Sectors (Risk Exposure)[1]"
              }`}
        </h1>
      </header>

      <div className="report-article__content">
        <section className="report-article__visual print-break-after">
          <SectorsChart
            reportName={reportName}
            id={type !== "" ? `report-sectors-${type}` : "report-sectors"}
            isFullWidth={true}
          />
        </section>
        <section className="report-article__visual">
          <SectorsDataTable reportName={reportName} type={type} />
        </section>
      </div>
    </article>
  );
};

SectorsReport.propTypes = {
  reportName: PropTypes.string,
  type: PropTypes.string,
};

SectorsReport.defaultProps = {
  reportName: "Sector",
};

export default SectorsReport;
